export default {"src":"/_next/static/media/clrfund.c90ad361.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};